import { INLINE_SEARCH_FILTER_TYPE } from "search-filter/constants";
import isFilterInaccessible from "search-filter/logic/isFilterInaccessible";
const transformToInlineFilter = (filter) => {
  const updatedFilter = { ...filter };
  delete updatedFilter.id;
  updatedFilter.type = INLINE_SEARCH_FILTER_TYPE;
  return updatedFilter;
};
const transformInaccessibleFilters = (filters, userPermissions) => filters.map((filter) => {
  if (isFilterInaccessible(filter, userPermissions)) {
    return transformToInlineFilter(filter);
  }
  return filter;
});
export default transformInaccessibleFilters;
